/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Settings,
  Report,
  AccountBox,
  SignalCellularAlt,
  AccessTime,
  Group,
  HowToReg,
  MenuBook,
} from "@material-ui/icons";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../img/logo.png";
import Axios from "axios";
import { toast } from "react-toastify";

const getLocalStorageItem = (key, fallback = null) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
};

export default function Sidebar() {
  const CourseName = localStorage.getItem("CourseName");
  const Academy = localStorage.getItem("Academy");
  const Access = localStorage.getItem("Access");
  const user = getLocalStorageItem("PersonalHistory", [{}]);
  const [PersId] = useState(user[0]?.PersId || "");
  const courIds = localStorage.getItem("AccessRights") || "";
  const courId = courIds.substring(11, 14);
  const courseDisplayName =
    courId === "141"
      ? "นายทหารชั้นผู้บังคับฝูง (4 หมวดวิชา)"
      : courId === "041"
        ? "นายทหารชั้นผู้บังคับฝูง (5 หมวดวิชา)"
        : CourseName || "";
  const isWingCommander = courId === "041" || courId === "141";
  const switchToOtherWingCourse = () => {
    const persId = courIds.substring(0, 10);
    const otherId = courId === "041" ? "141" : "041";
    localStorage.setItem("AccessRights", persId + "-" + otherId);
    localStorage.setItem(
      "CourseName",
      courId === "041" ? "นายทหารชั้นผู้บังคับฝูง (4 หมวดวิชา)" : "นายทหารชั้นผู้บังคับฝูง (5 หมวดวิชา)"
    );
    window.location.reload();
  };
  const token = getLocalStorageItem("token", "");
  const navigate = useNavigate();

  const [selected, setSelected] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [dataSuccess, setSuccess] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [ldataid, setLDataId] = useState("");

  const delayInMilliseconds = 3000;

  const listStudent = async () => {
    try {
      const { data } = await Axios.get(
        `${process.env.REACT_APP_API}/menustudent/${PersId}/${courId}?token=${token}`
      );
      // console.log("data: ", data);
      return data[0] || [];
    } catch (error) {
      console.error("List student error:", error);
      setTimeout(() => {
        navigate("/");
        localStorage.clear();
      }, delayInMilliseconds);
    }
  };

  const loadData = async (student) => {
    if (!student?.CourseGrp || !student?.Seminar) return [];
    try {
      const { data } = await Axios.get(
        `${process.env.REACT_APP_API}/pageInsertScore/coursegrp/${student.CourseGrp}/${student.Seminar}/${courId}?token=${token}`
      );
      if (Access === "นทน.") {
        localStorage.setItem(
          "datastorage",
          JSON.stringify(data.map((e) => ({ ...e, courseid: courId })))
        );
      }
      return data || [];
    } catch (err) {
      console.error("Load data error:", err);
    }
  };

  const loadNor = async (student) => {
    if (!student?.CourseGrp) return [];
    try {
      const { data } = await Axios.get(
        `${process.env.REACT_APP_API}/getpercentment/courseid/${courId}/coursegrp/${student.CourseGrp}?token=${token}`
      );
      return data || [];
    } catch (err) {
      console.error("Load normal data error:", err);
    }
  };

  const chkSendScoreE = async (student) => {
    if (!student?.CourseGrp) return undefined;
    try {
      const { data } = await Axios.get(
        `${process.env.REACT_APP_API}/chkSendScore/${courIds}/${student.CourseGrp}?token=${token}`
      );
      return data[0]?.Chksendscore;
    } catch (err) {
      console.error("Check send score error:", err);
    }
  };

  const chkSucess = (val) => {
    if (Access === "นทน.") return val === "1";
    return !(
      val === undefined ||
      val === null ||
      val === "0" ||
      (Array.isArray(val) && val.length === 0)
    );
  };

  useEffect(() => {
    let cancelled = false;
    let logoutTimer;
    const fetchData = async () => {
      try {
        const student = await listStudent();
        if (cancelled) return;
        const hasStudentCourseGroup = !!student?.CourseGrp;
        const hasStudentSeminar = student?.Seminar !== undefined && student?.Seminar !== null;

        // Non-student users may not have CourseGrp/Seminar context in this API.
        // Skip score-related requests to avoid backend 400 from undefined params.
        if (!hasStudentCourseGroup || !hasStudentSeminar) {
          if (cancelled) return;
          setData(student || []);
          setSuccess(undefined);
          setSelected([]);
          setData2([]);
          setLoading(false);
          return;
        }

        const [success, scoreData, normalData] = await Promise.all([
          chkSendScoreE(student),
          loadData(student),
          loadNor(student),
        ]);

        if (cancelled) return;
        setData(student);
        setSuccess(success);
        setSelected(scoreData);
        setData2(normalData);
        setLoading(false);
      } catch (err) {
        if (cancelled) return;
        toast.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
        logoutTimer = setTimeout(() => {
          localStorage.clear();
          navigate("/");
        }, delayInMilliseconds);
      }
    };
    fetchData();
    return () => {
      cancelled = true;
      if (logoutTimer) clearTimeout(logoutTimer);
    };
  }, []);

  const result = Array.isArray(selected) ? selected : [];
  const storeitem = result.filter((item) => item?.persid === PersId);
  const merged = storeitem.map((item) => ({
    ...item,
    AccessRightsId: data.AccessRightsId,
  }));

  useEffect(() => {
    if (merged.length !== 0) {
      setLDataId(merged[0].id || merged[0].persid);
    }
  }, [merged.length]);

  const result2 = Array.isArray(data2) ? data2 : [];
  const storeitem1 = result2.filter((item) => item?.PersId === PersId);

  const dataToUse = merged.map((item) => ({
    courseid: courId,
    period: item.period,
    coursegrp: item.coursegrp,
    seminar: item.seminar,
    persid: item.persid,
    studentid: item.studentid,
    studentname: item.studentname,
    businessleave: item.businessleave,
    sickleave: item.sickleave,
    conductscore: item.conductscore,
    sumattendhrs: item.sumattendhrs,
    percentattendhrs: item.percentattendhrs,
    remark: item.remark,
    AccessRightsId: item.AccessRightsId,
  }));

  const dataOrdnr = storeitem1.map((item) => ({
    CourseGrp: item.CourseGrp,
    CourseId: item.CourseId,
    PersId: item.PersId,
    avg: item.avg,
    ordnr: item.ordnr ?? "-",
  }));

  const dataToUse1 = dataToUse.map((e) => ({
    ...e,
    ...dataOrdnr.find((s) => s.PersId === e.persid),
  }));

  //   console.log("dataToUse1: ", dataToUse1);

  return (
    <React.Fragment>
      {Access === "กรรมวิธีส่วนกลาง" && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <Link to="/PageEducationInfo" className="link">
                  <img src={Logo} alt="logo" className="logoSidebar" />
                </Link>
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>
                <Link to="/PageEstimate" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินผลการเรียน
                  </li>
                  <hr />
                </Link>
                <Link to="/PageAttribute" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินคุณลักษณะส่วนบุคคล
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSummarize" className="link">
                  <li className="sidebarListItem">
                    <SignalCellularAlt className="sidebarIcon" />
                    ผลการศึกษาสรุปรวม
                  </li>
                  <hr />
                </Link>
                <Link to="/PageStudyResults" className="link">
                  <li className="sidebarListItem">
                    <Report className="sidebarIcon" />
                    รายงานผลการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSubject" className="link">
                  <li className="sidebarListItem">
                    <MenuBook className="sidebarIcon" />
                    หมวดวิชาของสถานศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PagePersonalAttributes" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    คุณลักษณะส่วนบุคคลทั้งหมด
                  </li>
                  <hr />
                </Link>
                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
                <Link to="/PageManage" className="link">
                  <li className="sidebarListItem">
                    <Settings className="sidebarIcon" />
                    จัดการสมาชิก
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "ปกครอง" && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <Link to="/PageEducationInfo" className="link">
                  <img src={Logo} alt="logo" className="logoSidebar" />
                </Link>
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link active">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>

                <Link to="/PageAttribute" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินคุณลักษณะส่วนบุคคล
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSummarize" className="link">
                  <li className="sidebarListItem">
                    <SignalCellularAlt className="sidebarIcon" />
                    ผลการศึกษาสรุปรวม
                  </li>
                  <hr />
                </Link>

                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "นทน." && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <img src={Logo} alt="logo" className="logoSidebar" />
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>
                <Link
                  to="/PageEditInsertScore"
                  className="link"
                  state={{
                    id: ldataid,
                    prev_page: 0,
                    newdatastorage: "",
                  }}
                >
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>

                {chkSucess(dataSuccess) || isLoading ? (
                  courId === "074" ||
                  courId === "075" ||
                  courId === "082" ||
                  courId === "083" ? (
                    <Link
                      to="/PagePrintStudyResultsOne"
                      state={{
                        coursegrp: dataToUse.coursegrp,
                        seminar: dataToUse.seminar,
                        businessleave: dataToUse.businessleave,
                        sickleave: dataToUse.sickleave,
                        percentattendhrs: dataToUse.percentattendhrs,
                        period: dataToUse.period,
                        PersId: dataToUse.persid,
                        AccessRightsId: dataToUse.AccessRightsId,
                        Cutstring: dataToUse.courseid,
                        CourseGrp: dataToUse.coursegrp,
                        ordnr: dataOrdnr.ordnr,
                        imgInstrId: dataToUse.InstructorId
                          ? dataToUse.InstructorId
                          : "-",
                        imgpath: dataToUse.SignatureImg
                          ? dataToUse.SignatureImg
                          : "-",
                        chkattackfile: "0",
                        dateattechfile: "-",
                        data: dataToUse1,
                      }}
                      className="link"
                    >
                      <li className="sidebarListItem">
                        <Report className="sidebarIcon" />
                        รายงานผลการศึกษา
                      </li>
                      <hr />
                    </Link>
                  ) : (
                    <Link
                      to={`/PagePrintStudyResults`}
                      state={{
                        coursegrp: dataToUse.coursegrp,
                        seminar: dataToUse.seminar,
                        businessleave: dataToUse.businessleave,
                        sickleave: dataToUse.sickleave,
                        percentattendhrs: dataToUse.percentattendhrs,
                        period: dataToUse.period,
                        PersId: dataToUse.persid,
                        AccessRightsId: dataToUse.AccessRightsId,
                        Cutstring: dataToUse.Cutstring,
                        CourseGrp: dataToUse.CourseGrp,
                        ordnr: dataOrdnr.ordnr,
                        imgInstrId: dataToUse.InstructorId
                          ? dataToUse.InstructorId
                          : "-",
                        imgpath: dataToUse.SignatureImg
                          ? dataToUse.SignatureImg
                          : "-",
                        chkattackfile: "0",
                        dateattechfile: "-",
                        data: dataToUse1,
                      }}
                      className="link"
                    >
                      <li className="sidebarListItem">
                        <Report className="sidebarIcon" />
                        รายงานผลการศึกษา
                      </li>
                      <hr />
                    </Link>
                  )
                ) : (
                  ""
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "อาจารย์ประจำหมวดวิชา" && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <img src={Logo} alt="logo" className="logoSidebar" />
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link active">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>
                <Link to="/PageEstimate" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินผลการเรียน
                  </li>
                  <hr />
                </Link>
                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "วัดผล" && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <Link to="/PageEducationInfo" className="link">
                  <img src={Logo} alt="logo" className="logoSidebar" />
                </Link>
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link active">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>
                <Link to="/PageEstimate" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินผลการเรียน
                  </li>
                  <hr />
                </Link>
                <Link to="/PageAttribute" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินคุณลักษณะส่วนบุคคล
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSummarize" className="link">
                  <li className="sidebarListItem">
                    <SignalCellularAlt className="sidebarIcon" />
                    ผลการศึกษาสรุปรวม
                  </li>
                  <hr />
                </Link>
                <Link to="/PageStudyResults" className="link">
                  <li className="sidebarListItem">
                    <Report className="sidebarIcon" />
                    รายงานผลการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSubject" className="link">
                  <li className="sidebarListItem">
                    <MenuBook className="sidebarIcon" />
                    หมวดวิชาของสถานศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PagePersonalAttributes" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    คุณลักษณะส่วนบุคคลทั้งหมด
                  </li>
                  <hr />
                </Link>
                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "กรรมวิธี" && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <Link to="/PageEducationInfo" className="link">
                  <img src={Logo} alt="logo" className="logoSidebar" />
                </Link>
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link active">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>
                <Link to="/PageEstimate" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินผลการเรียน
                  </li>
                  <hr />
                </Link>
                <Link to="/PageAttribute" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินคุณลักษณะส่วนบุคคล
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSummarize" className="link">
                  <li className="sidebarListItem">
                    <SignalCellularAlt className="sidebarIcon" />
                    ผลการศึกษาสรุปรวม
                  </li>
                  <hr />
                </Link>
                <Link to="/PageStudyResults" className="link">
                  <li className="sidebarListItem">
                    <Report className="sidebarIcon" />
                    รายงานผลการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSubject" className="link">
                  <li className="sidebarListItem">
                    <MenuBook className="sidebarIcon" />
                    หมวดวิชาของสถานศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PagePersonalAttributes" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    คุณลักษณะส่วนบุคคลทั้งหมด
                  </li>
                  <hr />
                </Link>
                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
                <Link to="/PageManage" className="link">
                  <li className="sidebarListItem">
                    <Settings className="sidebarIcon" />
                    จัดการสมาชิก
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "ผอ." && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <Link to="/PageEducationInfo" className="link">
                  <img src={Logo} alt="logo" className="logoSidebar" />
                </Link>
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link active">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>
                <Link to="/PageEstimate" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินผลการเรียน
                  </li>
                  <hr />
                </Link>
                <Link to="/PageAttribute" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินคุณลักษณะส่วนบุคคล
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSummarize" className="link">
                  <li className="sidebarListItem">
                    <SignalCellularAlt className="sidebarIcon" />
                    ผลการศึกษาสรุปรวม
                  </li>
                  <hr />
                </Link>
                <Link to="/PageStudyResults" className="link">
                  <li className="sidebarListItem">
                    <Report className="sidebarIcon" />
                    รายงานผลการศึกษา
                  </li>
                  <hr />
                </Link>

                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
      {Access === "วัดผลส่วนกลาง" && (
        <div className="sidebar">
          <div className="sidebarWrapper">
            <div className="sidebarMenu">
              <div className="imgSidebar">
                <Link to="/PageEducationInfo" className="link">
                  <img src={Logo} alt="logo" className="logoSidebar" />
                </Link>
              </div>
              <div className="containerTextTitleSidebar">
                <p className="sidebarTitle">สถานศึกษา {Academy}</p>
                <p className="sidebarTitle">หลักสูตร {courseDisplayName}</p>
                {isWingCommander && (
                  <p className="sidebarTitle" style={{ marginTop: 4, marginBottom: 0 }}>
                    <button
                      type="button"
                      onClick={switchToOtherWingCourse}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "inherit",
                        fontFamily: "inherit",
                      }}
                    >
                      สลับไปดูข้อมูล{courId === "041" ? " 4 หมวดวิชา" : " 5 หมวดวิชา"}
                    </button>
                  </p>
                )}
              </div>

              <ul className="sidebarList">
                <Link to="/PageHistory" className="link">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้ใช้
                  </li>
                  <hr />
                </Link>

                <Link to="/PageHistoyrS" className="link active">
                  <li className="sidebarListItem ">
                    <AccountBox className="sidebarIcon" />
                    ทะเบียนประวัติผู้เข้ารับการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageInsertScore" className="link">
                  <li className="sidebarListItem">
                    <AccessTime className="sidebarIcon" />
                    ชั่วโมงการศึกษา และคะแนนความประพฤติ
                  </li>
                  <hr />
                </Link>
                <Link to="/PageEstimate" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินผลการเรียน
                  </li>
                  <hr />
                </Link>
                <Link to="/PageAttribute" className="link">
                  <li className="sidebarListItem">
                    <HowToReg className="sidebarIcon" />
                    การวัด และประเมินคุณลักษณะส่วนบุคคล
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSummarize" className="link">
                  <li className="sidebarListItem">
                    <SignalCellularAlt className="sidebarIcon" />
                    ผลการศึกษาสรุปรวม
                  </li>
                  <hr />
                </Link>
                <Link to="/PageStudyResults" className="link">
                  <li className="sidebarListItem">
                    <Report className="sidebarIcon" />
                    รายงานผลการศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PageSubject" className="link">
                  <li className="sidebarListItem">
                    <MenuBook className="sidebarIcon" />
                    หมวดวิชาของสถานศึกษา
                  </li>
                  <hr />
                </Link>
                <Link to="/PagePersonalAttributes" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    คุณลักษณะส่วนบุคคลทั้งหมด
                  </li>
                  <hr />
                </Link>
                <Link to="/PageListTeacher" className="link">
                  <li className="sidebarListItem">
                    <Group className="sidebarIcon" />
                    รายชื่อเจ้าหน้าที่
                  </li>
                  <hr />
                </Link>
                <Link to="/PageManage" className="link">
                  <li className="sidebarListItem">
                    <Settings className="sidebarIcon" />
                    จัดการสมาชิก
                  </li>
                  <hr />
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
